import { useRealtimeConnected } from './useRealtimeConnected';

/**
 * The poll interval of a query that an event also keeps fresh (owner rule: "We have websockets
 * now, so we should never poll unless the websocket is down"). Give it the interval the screen
 * uses with no socket (0 = no poll now):
 * - 0 stays 0: a screen that waits for nothing does not poll.
 * - The socket is connected: 0. The event of the change reads the data again
 *   (`realtimeEventTags.ts`), and a later connection after a break reads every tag of the map
 *   again, so an event that went by while the socket was down is not lost.
 * - The socket is not connected, or there is no provider: the screen's own interval.
 */
export function useRealtimePollInterval(pollMs: number): number {
  const isConnected = useRealtimeConnected();
  if (pollMs <= 0 || isConnected) {
    return 0;
  }
  return pollMs;
}
